import React from 'react'
import { capitalizeFirstLetter } from '../Utils/index'

const RegionSearch = ({ filter, searchString, setSearchString }) => {
  return (
    <div className='formField'>
      <label htmlFor='regionSearch'>
        Search within: {capitalizeFirstLetter(filter)}...
      </label>
      <input
        className='regionSearch shadow'
        name='regionSearch'
        type='text'
        placeholder='Search...'
        value={searchString}
        onChange={(e) => setSearchString(e.target.value.trim())}
      ></input>
    </div>
  )
}

export default RegionSearch
